import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MapPin, CheckCircle2, XCircle, ArrowRight } from "lucide-react";
import { http, errMsg } from "../lib/api";

export const PincodeChecker = ({ compact = false }) => {
  const [pin, setPin] = useState(() => localStorage.getItem("hw_pin") || "");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const check = async (e) => {
    e.preventDefault();
    setLoading(true); setError(""); setResult(null);
    try {
      const { data } = await http.post("/pincode/check", { pincode: pin });
      setResult(data);
      localStorage.setItem("hw_pin", pin);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="pincode-checker" className={compact ? "" : "card p-5 sm:p-6"}>
      <p className="flex items-center gap-2 text-sm font-semibold"><span className="grid h-7 w-7 place-items-center rounded-full bg-sand text-sheesham"><MapPin className="h-3.5 w-3.5" /></span> Check delivery to your Hyderabad home</p>
      <form onSubmit={check} className="mt-3 flex gap-2">
        <input
          data-testid="pincode-check-input" inputMode="numeric" maxLength={6} value={pin}
          onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))} placeholder="PIN code, e.g. 500032"
          className="input h-12 min-w-0 flex-1"
        />
        <button data-testid="pincode-check-button" disabled={pin.length !== 6 || loading} className="btn-walnut h-12 px-5 py-0">{loading ? "Checking" : <>Check <ArrowRight className="h-4 w-4" /></>}</button>
      </form>
      <AnimatePresence mode="wait">
        {result?.serviceable && (
          <motion.p key="ok" initial={{ opacity: 0, y: 6 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }} data-testid="pincode-check-result" className="mt-3 flex items-start gap-2 rounded-xl bg-neem/10 px-3 py-2.5 text-sm text-neem">
            <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0" />
            <span><b>{result.message}.</b> Arrives by {result.to_date}.</span>
          </motion.p>
        )}
        {result && !result.serviceable && (
          <motion.p key="no" initial={{ opacity: 0, y: 6 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }} data-testid="pincode-check-result" className="mt-3 flex items-start gap-2 rounded-xl bg-destructive/10 px-3 py-2.5 text-sm text-destructive"><XCircle className="mt-0.5 h-4 w-4 shrink-0" />{result.message}</motion.p>
        )}
        {error && <motion.p key="err" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} data-testid="pincode-check-error" className="mt-3 text-sm text-destructive">{error}</motion.p>}
      </AnimatePresence>
    </div>
  );
};
